import {
  makeStyles,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ReferenceArrayInput, required, TextInput } from 'react-admin';
import { memoize } from 'lodash';
import FundTagApi from '../../core/apis/FundTagApi';
import GridInputFilter from '../../core/components/inputs/GridInputFilter';
import {
  fieldLengthValidator,
  isFieldContainsOnlySpaces
} from '../../core/utils/index';

export const useStyles = makeStyles({
  gridItem: {
    paddingBottom: '0px !important'
  },
  gridItemRelative: {
    position: 'relative',
    '& > div > div > div:nth-child(2)': {
      maxWidth: 'calc(25% - 12px)'
    }
  },
  radioGroup: {
    position: 'absolute',
    top: '10px',
    right: 0
  }
});

const FundTagSummary = props => {
  const { creation, record, resetFilter, hasEditPermission } = props;

  const classes = useStyles();
  const [formErrors, setFormErrors] = useState({});
  const [filter, setFilter] = useState(creation ? 'ALL' : 'ONLY_ASSIGNED');

  useEffect(() => {
    if (!creation && resetFilter) {
      setFilter('ONLY_ASSIGNED');
    }
  }, [creation, resetFilter]);

  const selectedFundIds = record.fundIds;
  const disableCheckBoxes = creation ? false : !hasEditPermission;

  const validateFundTagName = memoize(async (value, _allValues, fieldState) => {
    if (record && value === record.name) {
      return;
    }
    if (fieldState.active) {
      const fundTagNameValid = !!value.trim();
      let error;

      if (!fundTagNameValid) {
        error = `Fund Tag Name can't be empty space(s)`;
      } else {
        const nameExists = await FundTagApi.checkFundTagNameExists(value);
        if (nameExists) {
          error = 'Fund Tag Name already exists';
        } else {
          error = undefined;
        }
      }
      setFormErrors({ ...formErrors, name: error });
      return error;
    }
    return formErrors.name;
  });

  const ReferenceArrayInputProps = {
    label: '',
    optionTextLabel: 'Fund Name',
    optionValueLabel: 'Fund ID',
    additionalColumns: [
      { label: 'Status', name: 'status', isStatusColumn: true }
    ],
    resource: 'funds',
    reference: 'funds',
    source: 'fundIds'
  };

  const filterFunction = choices => {
    if (filter === 'ALL') {
      return choices;
    }
    if (typeof choices !== 'undefined') {
      return choices.filter(choice => {
        return !!selectedFundIds.find(item => item === choice.id);
      });
    }
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.gridItem}>
          <Grid item xs={3} className={classes.gridItem}>
            <TextInput
              source="name"
              label="Tag Name"
              validate={[
                required(),
                isFieldContainsOnlySpaces,
                fieldLengthValidator(30),
                validateFundTagName
              ]}
              options={{ autoComplete: 'off' }}
              variant="standard"
              helperText={false}
            />
          </Grid>
          <Grid item xs={12} className={classes.gridItem}>
            <TextInput
              source="description"
              label="Description"
              validate={[isFieldContainsOnlySpaces, fieldLengthValidator(1000)]}
              options={{ autoComplete: 'off' }}
              variant="standard"
              helperText={false}
              multiline={true}
              rows="3"
            />
          </Grid>
        </Grid>
        <Grid item xs={12} className={`${classes.gridItemRelative}`}>
          {!creation && (
            <RadioGroup
              className={classes.radioGroup}
              aria-label="radioFilter"
              name="radioFilter"
              value={filter}
              onChange={({ target }) => setFilter(target.value)}
              row
            >
              <FormControlLabel
                value="ALL"
                control={<Radio color="primary" />}
                label="Show All"
              />
              <FormControlLabel
                value="ONLY_ASSIGNED"
                control={<Radio color="primary" />}
                label="Show Assigned"
              />
            </RadioGroup>
          )}
          <ReferenceArrayInput
            perPage={-1}
            sort={{ field: 'name', order: 'ASC' }}
            {...ReferenceArrayInputProps}
          >
            <GridInputFilter
              height={
                creation
                  ? `${document.documentElement.scrollHeight - 500}px`
                  : `${document.documentElement.scrollHeight - 530}px`
              }
              optionText="name"
              optionValue="id"
              filter={filterFunction}
              disableCheckBoxes={disableCheckBoxes}
              emptyMessage={'There are no Funds assigned.'}
            />
          </ReferenceArrayInput>
        </Grid>
      </Grid>
    </div>
  );
};

export default FundTagSummary;
